const ExperienceConcept = () => {
  return (
    <section className="py-24 bg-[#111111] text-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-14">
          <p className="text-sm uppercase tracking-[0.35em] text-[#b7a76a] mb-4">
            Experience Concept
          </p>

          <h2 className="text-4xl md:text-6xl font-bold leading-tight">
            Oltre il food truck. <br />
            Un format esperienziale.
          </h2>

          <p className="max-w-3xl mx-auto mt-6 text-lg md:text-xl text-[#d8d0a8] leading-relaxed">
            Foody Burger 49 può diventare un vero elemento scenografico per eventi,
            brand activation, soft clubbing e hospitality esperienziale.
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-10 items-center">
          <div className="rounded-2xl overflow-hidden shadow-2xl border border-white/10">
            <img
              src="/images/food-truck-dj-set-brand-activation-concept.png"
              alt="DJ set a bordo food truck vintage per brand activation ed eventi"
              className="w-full h-full object-cover"
            />
          </div>

          <div>
            <p className="text-sm uppercase tracking-[0.25em] text-[#c9b66b] mb-4">
              DJ Set • Soft Clubbing • Brand Activation
            </p>

            <h3 className="text-3xl md:text-4xl font-bold mb-6">
              Il truck diventa il cuore dell’evento.
            </h3>

            <p className="text-lg text-[#e8dfb8] leading-relaxed mb-8">
              Console DJ frontale, illuminazione scenografica e impianto audio
              trasformano il mezzo in una piattaforma visiva capace di attrarre
              pubblico e generare contenuti.
            </p>

            <ul className="space-y-4 text-[#f5f0d5]">
              <li>• Configurazione scenografica su richiesta</li>
              <li>• Ideale per brand activation e eventi lifestyle</li>
              <li>• Co-branding personalizzabile</li>
              <li>• Format replicabile per tour e roadshow</li>
            </ul>

            <p className="mt-8 text-sm text-[#aaa] italic">
              Immagine concept a scopo dimostrativo.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ExperienceConcept;